import { render } from "./TopNavBar.vue?vue&type=template&id=453fd27e&scoped=true&ts=true"
import script from "./TopNavBar.vue?vue&type=script&lang=ts"
export * from "./TopNavBar.vue?vue&type=script&lang=ts"

import "./TopNavBar.vue?vue&type=style&index=0&id=453fd27e&scoped=true&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QLTS/QLTS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453fd27e"]])

export default __exports__